import courseraOpenBadgesEpicClient from 'bundles/epic/clients/courseraOpenBadges';

export const isCourseraBadgeEnabled = () => {
  // https://tools.coursera.org/epic/experiment/AFagCOpDEe-6NxLsF4c5gw
  return courseraOpenBadgesEpicClient.preview('courseraBadgeEnabled');
};
